export const AUTH_API_URL = "/auth/api";
